import { Typography, Box } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

const LearnMoreContent = () => {
  return (
    <Box>
      <Typography style={{ fontSize: 12 }}>
        Casting.com allows you to make your profile public, enabling anyone to view it without requiring a secure
        account. Please note that a public profile may also be indexed by search engines like Google, Bing etc. If you
        own a personal domain, you can also direct it to your preferred Casting.com profile.
        {/* <Typography component={'span'} style={{ color: COLORS.PRIMARY, fontSize: 'inherit' }}>
          {' '}
          Click here to learn how
        </Typography> */}
      </Typography>
    </Box>
  );
};

export default LearnMoreContent;
